// extracted by mini-css-extract-plugin
export default {"text":"styles_text__O6gh1","tooltipIconText":"styles_tooltipIconText__YxUIG","icon":"styles_icon__wYJw2","ellipsis":"styles_ellipsis__b7qwf","unit":"styles_unit__RYjxT"};